export interface TeamVerificationMessageProps {
  teamName: string;
  teamId: string;
  firstName: string;
  lastName: string;
  createdAt: string;
  email: string | null;
  phoneNumber: string | null;
  userId: string;
  background: string;
  isCreation?: boolean;
}

export const getTeamVerificationMessage = ({
  teamName,
  firstName,
  lastName,
  createdAt,
  email,
  phoneNumber,
  claimId,
  background,
  isCreation,
}: TeamVerificationMessageProps & { claimId?: string }) => ({
  unfurl_links: false,
  unfurl_media: false,
  blocks: [
    {
      type: 'section',
      text: {
        type: 'mrkdwn',
        text: isCreation
          ? `*NEW TEAM CREATION REQUEST*:\n*<https://admin.baseballnearyou.com/teams/claims/show/${claimId}|Click here: ${`${firstName} ${lastName}`}>*`
          : `*TEAM VERIFICATION REQUEST*:\n*<https://admin.baseballnearyou.com/teams/claims/show/${claimId}|Click here: ${`${firstName} ${lastName}`}>*`,
      },
    },
    {
      type: 'divider',
    },
    {
      type: 'section',
      fields: [
        {
          type: 'mrkdwn',
          text: `*Team name:*\n${teamName}`,
        },
        {
          type: 'mrkdwn',
          text: `*Date submitted:*\n${createdAt}`,
        },
        {
          type: 'mrkdwn',
          text: `*Email:*\n${email}`,
        },
        {
          type: 'mrkdwn',
          text: `*Phone:*\n${phoneNumber}`,
        },
        {
          type: 'mrkdwn',
          text: `*Background:*\n${background}`,
        },
      ],
    },
  ],
});
